<template>
  <div class="page">
    <div class="container">
      <div
        class="page-wrap"
        v-if="page"
      >
        <div
          class="page-title"
          v-if="showPageTitle() && $route.query.type !== 'new'"
        ></div>
        <h1
          class="page-title__second"
          :class="{ big: isBigSecondTitle(), new: $route.query.type === 'new' }"
          v-if="$route.query.type !== 'new'"
        >
          {{ page.title }}
        </h1>

        <div v-if="pageSectionBlocks.length">
          <static-content :isNews="$route.query.type === 'new'">
            <template v-if="showPageTitle() && $route.query.type === 'new'">
              <h1 class="page-title__second" :class="{ big: isBigSecondTitle(), new: $route.query.type === 'new' }">
                {{ page.title }}
              </h1>
            </template>
            <template v-if="page.configType === 'our-methodists'">
              <div class="our-metodist--wrap">
                <template v-for="block in pageSectionBlocks">
                  <metodistBlock
                    :info="block"
                    @video-play="handleVideoPlay"
                  />
                </template>
              </div>
            </template>
            <template v-else>
              <div
                v-for="block in pageSectionBlocks"
                :key="block.id"
                :class="`${block.type}--block`"
              >
                <blogFeedback v-if="block.type === 'feedback'" :info="block" />
                <blogProduct v-if="block.type === 'product'" :info="block" />
                <columnBlock
                  :list="block.items"
                  v-if="block.items"
                  class="scrolled"
                />
                <imageLeft
                  v-if="block.type === 'image_left'"
                  :info="block"
                  style="margin-bottom: 24px"
                  class="scrolled"
                />
                <imageLeft
                  v-if="block.type === 'image_right'"
                  :info="block"
                  :imageRight="true"
                  style="margin-bottom: 24px"
                  class="scrolled"
                />
                <block-with-video
                  v-if="block.type === 'block_with_video'"
                  :info="block"
                  class="scrolled"
                />
                <title-with-description
                  v-if="block.type === 'title_with_description'"
                  :info="block"
                  class="scrolled"
                />
                <title-with-description
                  v-if="block.type === 'title_with_center_description'"
                  :positionCenter="true"
                  :info="block"
                  class="scrolled"
                />
                <phrase
                  v-if="block.type === 'phrase'"
                  :info="block"
                  class="scrolled"
                />
                <block-with-image
                  v-if="block.type === 'block_with_image'"
                  :info="block"
                  class="scrolled"
                />
                <description
                  v-if="block.type === 'description'"
                  :info="block"
                  class="scrolled"
                />
                <block-with-image-with-button
                  v-if="block.type === 'block_with_image_with_button'"
                  :info="block"
                  class="scrolled"
                />
                <banner
                  v-if="block.type === 'banner'"
                  :info="block"
                  class="scrolled"
                />
              </div>
            </template>
            <template v-if="$route.query.type === 'new'">
              <div>
                <div class="share-block">
                <span>
                  {{ $t('shareThisArticle') }}:
                </span>
                  <!--                Instagram -->
                  <button @click="shareInstagram()" style="color: #e4405f">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.404 0H4.2327C1.89876 0 0 1.89875 0 4.23271V11.404C0 13.7379 1.89876 15.6367 4.2327 15.6367H11.4041C13.7379 15.6367 15.6367 13.7379 15.6367 11.404V4.23271C15.6367 1.89875 13.7379 0 11.404 0ZM14.72 11.404C14.72 13.2325 13.2324 14.72 11.404 14.72H4.2327C2.40422 14.72 0.916688 13.2325 0.916688 11.404V4.23271C0.916688 2.40422 2.40422 0.916684 4.2327 0.916684H11.4041C13.2324 0.916684 14.72 2.40422 14.72 4.23271V11.404Z"
                        fill="#E4405F"
                      />
                      <path
                        d="M7.8185 3.54297C5.46094 3.54297 3.54297 5.46093 3.54297 7.8185C3.54297 10.1761 5.46094 12.094 7.8185 12.094C10.176 12.094 12.094 10.1761 12.094 7.8185C12.094 5.46093 10.176 3.54297 7.8185 3.54297ZM7.8185 11.1774C5.96652 11.1774 4.45967 9.67061 4.45967 7.8185C4.45967 5.96651 5.96652 4.45966 7.8185 4.45966C9.67062 4.45966 11.1773 5.96651 11.1773 7.8185C11.1773 9.67061 9.67062 11.1774 7.8185 11.1774Z"
                        fill="#E4405F"
                      />
                      <path
                        d="M12.1969 2.02344C11.5003 2.02344 10.9336 2.59023 10.9336 3.28681C10.9336 3.98351 11.5003 4.5503 12.1969 4.5503C12.8936 4.5503 13.4604 3.98351 13.4604 3.28681C13.4604 2.5901 12.8936 2.02344 12.1969 2.02344ZM12.1969 3.63349C12.0059 3.63349 11.8502 3.47792 11.8502 3.28681C11.8502 3.09557 12.0059 2.94012 12.1969 2.94012C12.3881 2.94012 12.5438 3.09557 12.5438 3.28681C12.5438 3.47792 12.3881 3.63349 12.1969 3.63349Z"
                        fill="#E4405F"
                      />
                    </svg>
                  </button>
                  <!--                Viber -->
                  <button @click="shareViber()" style="color: #665cac">
                    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M1.79527 1.00017C1.69162 0.99799 1.58858 1.01633 1.49218 1.05411C1.39578 1.09189 1.30797 1.14835 1.2339 1.22019C1.15983 1.29203 1.10098 1.37779 1.06082 1.47245C1.02065 1.56712 0.999977 1.66877 1 1.77145V14.1077C0.999977 14.2104 1.02065 14.3121 1.06082 14.4067C1.10098 14.5014 1.15983 14.5871 1.2339 14.659C1.30797 14.7308 1.39578 14.7873 1.49218 14.8251C1.58858 14.8628 1.69162 14.8812 1.79527 14.879H2.57396V17L6.8568 14.879H14.2213C14.4278 14.879 14.6259 14.7977 14.7719 14.6531C14.918 14.5085 15 14.3123 15 14.1077V1.77145C15 1.56689 14.918 1.37072 14.7719 1.22608C14.6259 1.08143 14.4278 1.00017 14.2213 1.00017H1.79527ZM3.74201 3.69963H6.06154C6.16287 3.70549 6.2585 3.748 6.33027 3.81909C6.40205 3.89018 6.44497 3.9849 6.45089 4.08527C6.43821 4.6112 6.52677 5.1347 6.71183 5.62782C6.79337 5.79261 6.81185 5.98107 6.76388 6.15833C6.7159 6.33558 6.60471 6.48961 6.45089 6.59191L5.62248 7.41241C5.98483 8.11122 6.45744 8.74828 7.02248 9.29957C7.58444 9.85597 8.22823 10.3249 8.93195 10.6903L9.76035 9.86982C9.86363 9.71747 10.0192 9.60733 10.1981 9.55981C10.3771 9.51229 10.5674 9.53061 10.7337 9.61136C11.2316 9.79466 11.7601 9.88237 12.2911 9.86982C12.3925 9.87568 12.4881 9.91819 12.5599 9.98928C12.6316 10.0604 12.6746 10.1551 12.6805 10.2555V12.5693C12.6746 12.6696 12.6316 12.7644 12.5599 12.8355C12.4881 12.9065 12.3925 12.9491 12.2911 12.9549C9.94447 12.8627 7.71919 11.8975 6.05931 10.252C4.39944 8.60638 3.42702 6.40143 3.33609 4.07706C3.34395 3.97816 3.38772 3.88542 3.4593 3.81602C3.53089 3.74663 3.62544 3.70528 3.72544 3.69963H3.74201Z"
                        stroke="#665CAC"
                        stroke-width="0.855677"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    </svg>
                  </button>
                  <!--                Telegram -->
                  <button @click="shareTelegram()" style="color: #0088cc">
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16.8124 0.138975C16.7378 0.0709574 16.6471 0.0257342 16.55 0.00818505C16.4529 -0.00936406 16.3531 0.0014272 16.2614 0.0393944L0.600708 6.51293C0.410225 6.59166 0.249064 6.73354 0.14143 6.91726C0.0337948 7.10098 -0.0145038 7.31663 0.00378716 7.53182C0.0220781 7.74701 0.105971 7.95012 0.242868 8.11065C0.379764 8.27118 0.562273 8.38047 0.762986 8.4221L4.94514 9.28975V14.2027C4.94523 14.4304 5.00975 14.653 5.13043 14.8417C5.2511 15.0305 5.42243 15.1768 5.62241 15.262C5.82239 15.3472 6.04191 15.3673 6.2528 15.3198C6.46368 15.2722 6.6563 15.1592 6.80594 14.9952L8.86456 12.74L12.0777 15.7151C12.2739 15.8985 12.5267 15.9998 12.7886 16C12.903 15.9998 13.0167 15.9808 13.1255 15.9437C13.304 15.884 13.4646 15.776 13.5913 15.6303C13.7179 15.4847 13.8062 15.3065 13.8473 15.1136L16.9862 0.699726C17.0083 0.598394 17.0038 0.492622 16.9731 0.393808C16.9425 0.294995 16.8869 0.206885 16.8124 0.138975ZM0.930675 7.45813C0.927715 7.4497 0.927715 7.44044 0.930675 7.43201C0.934157 7.42915 0.938078 7.42694 0.942266 7.42548L13.284 2.3224L5.30138 8.36251L0.942266 7.46139L0.930675 7.45813ZM6.13828 14.3145C6.11698 14.3378 6.08958 14.3539 6.05958 14.3608C6.02958 14.3676 5.99833 14.3649 5.96981 14.3529C5.9413 14.3409 5.91681 14.3202 5.89947 14.2934C5.88213 14.2667 5.87273 14.2351 5.87245 14.2027V9.96723L8.16677 12.0894L6.13828 14.3145ZM12.9439 14.8924C12.9382 14.92 12.9256 14.9454 12.9074 14.9661C12.8892 14.9868 12.866 15.0019 12.8404 15.0099C12.8142 15.0196 12.7861 15.0217 12.7589 15.016C12.7317 15.0102 12.7065 14.9968 12.6858 14.9773L6.15374 8.9249L15.841 1.59187L12.9439 14.8924Z"
                        fill="#0088CC"
                      />
                    </svg>
                  </button>
                  <!--                Fb -->
                  <button @click="shareFacebook()" style="color: #1877f2">
                    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8.35688 2.65667H10V0.112668C9.71652 0.0780001 8.7416 0 7.6062 0C5.23714 0 3.61428 1.32467 3.61428 3.75934V6H1V8.844H3.61428V16H6.81951V8.84468H9.32805L9.72627 6.00067H6.81876V4.04133C6.81951 3.21934 7.06849 2.65667 8.35688 2.65667Z"
                        fill="#1877F2"
                      />
                    </svg>
                  </button>
                  <!--                Mail -->
                  <button @click="shareMail()">
                    <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_2805_11119)">
                        <path
                          d="M17.8113 0.695312H1.65747C1.14975 0.695312 0.734375 1.11068 0.734375 1.61837V11.7722C0.734375 12.2799 1.14975 12.6953 1.65747 12.6953H17.8113C18.319 12.6953 18.7344 12.28 18.7344 11.7722V1.61837C18.7344 1.11068 18.319 0.695312 17.8113 0.695312ZM17.4649 1.38757L10.2654 6.78764C10.1359 6.88615 9.93723 6.94778 9.73434 6.94687C9.53149 6.94778 9.33282 6.88615 9.20334 6.78764L2.00383 1.38757H17.4649ZM13.6191 7.14395L17.5422 11.9901C17.5462 11.995 17.551 11.9987 17.5552 12.0031H1.91359C1.91773 11.9985 1.92259 11.995 1.92652 11.9901L5.84961 7.14395C5.96981 6.99535 5.94703 6.77748 5.79814 6.657C5.64954 6.5368 5.43167 6.55959 5.31144 6.70823L1.42667 11.5071V1.82028L8.78818 7.34142C9.06489 7.54751 9.40155 7.63821 9.7343 7.63913C10.0666 7.63842 10.4035 7.54772 10.6804 7.34142L18.0419 1.82028V11.507L14.1573 6.70823C14.037 6.55962 13.819 6.53677 13.6706 6.657C13.5217 6.7772 13.4989 6.99535 13.6191 7.14395Z"
                          fill="#4F4F4F"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2805_11119">
                          <rect width="19" height="13" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                  <!--                Copy -->
                  <button @click="copyLink()">
                    <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3.5 8.5C3.5 6.14333 3.5 4.96417 4.2325 4.2325C4.96417 3.5 6.14333 3.5 8.5 3.5H11C13.3567 3.5 14.5358 3.5 15.2675 4.2325C16 4.96417 16 6.14333 16 8.5V12.6667C16 15.0233 16 16.2025 15.2675 16.9342C14.5358 17.6667 13.3567 17.6667 11 17.6667H8.5C6.14333 17.6667 4.96417 17.6667 4.2325 16.9342C3.5 16.2025 3.5 15.0233 3.5 12.6667V8.5Z"
                        stroke="#4F4F4F"
                        stroke-width="0.8"
                      />
                      <path
                        d="M3.5 15.1667C2.83696 15.1667 2.20107 14.9033 1.73223 14.4344C1.26339 13.9656 1 13.3297 1 12.6667V7.66667C1 4.52417 1 2.9525 1.97667 1.97667C2.95333 1.00083 4.52417 1 7.66667 1H11C11.663 1 12.2989 1.26339 12.7678 1.73223C13.2366 2.20107 13.5 2.83696 13.5 3.5"
                        stroke="#4F4F4F"
                        stroke-width="0.8"
                      />
                    </svg>
                  </button>
                  <span style="margin-left: auto; display: flex; align-items: center; gap: 8px;">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7 1.75C4.10156 1.75 1.75 4.10156 1.75 7C1.75 9.89844 4.10156 12.25 7 12.25C9.89844 12.25 12.25 9.89844 12.25 7C12.25 4.10156 9.89844 1.75 7 1.75Z"
                      stroke="#333333"
                      stroke-miterlimit="10"
                    ></path>
                    <path
                      d="M7 3.5V7.4375H9.625"
                      stroke="#333333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  {{ page.createdAt.replaceAll('-', '.').split(' ')[0] }}
                </span>
                </div>
                <CommentsBlock
                  style="margin-top: 20px;"
                  :id="page.id"
                  :title="page.title"
                  :data="page.comments.data"
                  :type="'comments'"
                />
              </div>
            </template>
          </static-content>
        </div>

        <div
          class="education"
          v-if="page.configType === 'online-education' && webinarCourseThemes.length"
        >
          <div class="education-wrap">
            <p class="education-sub_title">{{ $t('selectASection') }}:</p>
            <ul
              class="education__head"
              :class="{ withImage: page.image }"
            >
              <li
                v-for="courseTheme in webinarCourseThemes"
                :key="courseTheme.id"
              >
                <router-link
                  :to="
                    $localize({
                      name: 'sub-page',
                      params: { slugPage: 'platform', slugIngredient: courseTheme.id },
                      query: { type: 'webinar' },
                    })
                  "
                >
                  <div class="education__head-icon">
                    <img
                      loading="lazy"
                      :src="courseTheme.image"
                      :alt="courseTheme.title"
                    />
                  </div>
                  <div class="education__head-desc">
                    <h2 v-html="courseTheme.title"></h2>
                    <p v-html="courseTheme.description"></p>
                  </div>
                </router-link>
              </li>
            </ul>
            <div
              class="education__head-img"
              v-if="page.image"
            >
              <img
                loading="lazy"
                :src="page.image"
                :alt="page.title"
              />
            </div>
          </div>

          <div
            class="education__patent"
            v-if="page.seminarBanner"
          >
            <div
              class="education__patent-wrap"
              :class="{ imageRight: 'imageRight' }"
            >
              <div class="education__patent-img">
                <img
                  loading="lazy"
                  :src="page.seminarBanner.image"
                  alt="patent-file"
                />
              </div>
              <div class="education__patent-text">
                <h2 class="education__patent-text__title">{{ page.seminarBanner.title }}</h2>
                <div
                  class="education__patent-text__description"
                  v-html="page.seminarBanner.description"
                ></div>
                <div class="education__patent-text__button">
                  <a
                    :href="page.seminarBanner.buttonLink"
                    class="main-button"
                  >
                    <span class="main-button__label">
                      {{ page.seminarBanner.buttonText }}
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="partners"
          v-if="page.partners"
        >
          <div
            class="page-partner"
            v-for="(partner, index) in page.partners.data"
            :key="index"
          >
            <partner :info="partner" />
          </div>
        </div>

        <template v-if="page.qualityCertificates">
          <div class="certificate-list">
            <div
              class="page-certificate"
              v-for="certificate in certificatesList"
              :key="certificate.id"
            >
              <certificate :info="certificate" />
            </div>
          </div>
          <div class="certificate-load">
            <main-button
              :outline="true"
              v-show="page.qualityCertificates.data.length !== certificatesList.length"
              :progress="loadingMoreContent"
              @change-event="loadMoreCertificates(3)"
              :label="$t('loadMore')"
            ></main-button>
          </div>
        </template>

        <template v-if="page.patents">
          <div class="patents">
            <div
              class="page-patent"
              v-for="patent in patentsList"
              :key="patent.id"
            >
              <patent :info="patent" />
            </div>
          </div>
          <div class="patent-load">
            <main-button
              :outline="true"
              v-show="page.patents.data.length !== patentsList.length"
              :progress="loadingMoreContent"
              @change-event="loadMorePatents(3)"
              :label="$t('loadMore')"
            ></main-button>
          </div>
        </template>

        <div v-if="page.videoPresentations">
          <div
            v-for="(item, index) in page.videoPresentations.data"
            :key="index"
            class="presentations"
          >
            <iframe
              width="100%"
              :src="'https://www.youtube-nocookie.com/embed/' + item.videoId"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <div class="presentations__content">
              <h2 v-html="item.title"></h2>
              <div
                class="presentations__content_description"
                v-html="item.description"
              ></div>
            </div>
          </div>
        </div>

        <template v-if="page.innovativeIngredients">
          <div class="innovatives">
            <router-link
              :to="
                $localize({
                  name: 'sub-page',
                  params: {
                    slugPage: page.slug,
                    slugIngredient: ingredient.id,
                  },
                  query: { title: $route.query.title, type: 'ingredient' },
                })
              "
              class="page-innovative"
              v-for="ingredient in ingredientsList"
              :key="ingredient.id"
            >
              <ingredients :info="ingredient" />
            </router-link>
          </div>
          <div class="innovatives-load">
            <main-button
              :outline="true"
              v-show="page.innovativeIngredients.data.length !== ingredientsList.length"
              :progress="loadingMoreContent"
              @change-event="loadMoreIngredients(3)"
              :label="$t('loadMore')"
            ></main-button>
          </div>
        </template>

        <template v-if="page.configType === 'scientific-news'">
          <div class="news">
            <div class="page-new">
              <blog-wrapper>
                <template v-for="item in newsList">
                  <blog-post :info="item" />
                </template>
              </blog-wrapper>
            </div>
          </div>
          <div class="news-load">
            <main-button
              :outline="true"
              v-show="newsPaginator.hasNextPage"
              :progress="loadingMoreContent"
              @change-event="loadMoreNews()"
              :label="$t('loadMore')"
            ></main-button>
          </div>
        </template>

        <div
          class="before-after"
          v-if="page.beforeAfters"
        >
          <div
            class="page-before__after"
            v-for="item in page.beforeAfters.data"
            :key="item.id"
          >
            <before-after :info="item" />
          </div>
        </div>

        <div
          class="protocols"
          v-if="page.catalogAndProtocols && page.catalogAndProtocols.data"
        >
          <div
            class="protocols-placeholder"
            v-if="!page.catalogAndProtocols.length && !page.catalogAndProtocols.data.length"
          >
            <h3>{{ $t('noProtocols') }}</h3>
          </div>
          <div
            class="page-protocol"
            v-for="item in page.catalogAndProtocols.data"
            :key="item.id"
          >
            <protocol :info="item" />
          </div>
        </div>

        <div
          class="terms"
          v-if="page.configType === 'terms-of-cooperation'"
        >
          <div
            class="page-term"
            v-for="(item, index) in cooperationTerms"
            :key="item.id"
          >
            <terms
              :info="item"
              :oposit="index % 2 !== 0"
            />
          </div>
        </div>

        <div
          class="page-button"
          v-if="page.configType === 'application-for-presentation'"
        >
          <main-button
            :label="$t('sendRequest')"
            @change-event="changeApplicationFormPopup(true)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import take from 'lodash/take'

  import blockWithImage from '../components/block-with-image/index.vue'
  import titleWithDescription from '../components/title-with-description/index.vue'
  import phrase from '../components/phrase/index.vue'
  import blockWithVideo from '../components/block-with-video/index.vue'
  import certificate from '../components/certificate/index.vue'
  import patent from '../components/patent/index.vue'
  import ingredients from '../components/ingredient/index.vue'
  import oneNew from '../components/new/index.vue'
  import beforeAfter from '../components/before-after/index.vue'
  import protocol from '../components/protocol/index.vue'
  import terms from '../components/terms/index.vue'
  import description from '../components/description/index.vue'
  import partner from '../components/partner/index.vue'
  import blockWithImageWithButton from '../components/block-with-image-with-button/index.vue'
  import banner from '../components/banner/index.vue'
  import staticContent from '@/components/static-content/index.vue'
  import imageLeft from '@/modules/pages/components/image-left'
  import columnBlock from '@/modules/pages/components/column-block/index.vue'
  import metodistBlock from './component/index.vue'
  import blogWrapper from "@/components/blog-wrapper/index.vue";
  import blogPost from "@/components/blog-post/index.vue";
  import blogProduct from "@/components/blog-product/index.vue";
  import CommentsBlock from "@/components/comment-block/index.vue";
  import blogFeedback from "@/components/blog-feedback/index.vue";

  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import dynamicsHead from '@/mixins/dynamics-head'

  export default {
    name: 'page-wrap',
    components: {
      CommentsBlock,
      banner,
      blockWithImage,
      titleWithDescription,
      phrase,
      blockWithVideo,
      certificate,
      patent,
      ingredients,
      oneNew,
      beforeAfter,
      protocol,
      terms,
      description,
      partner,
      blockWithImageWithButton,
      staticContent,
      imageLeft,
      columnBlock,
      metodistBlock,
      blogWrapper,
      blogPost,
      blogProduct,
      blogFeedback
    },
    data() {
      return {
        loadingMoreContent: false,
        currentlyPlaying: null,

        ingredientSkip: 4,
        certificatesSkip: 4,
        patentsSkip: 4,

        cooperationTerms: [],
        webinarCourseThemes: [],

        newsList: [],
        newsPaginator: {
          hasNextPage: false,
          page: 1,
          perPage: 3,
        },
      }
    },
    computed: {
      ...mapGetters({
        page: 'pages/page',
        pageSectionBlocks: 'pages/pageSectionBlocks',

        headerMenu: 'setting/headerMenu',
      }),
      ingredientsList() {
        return take(this.page.innovativeIngredients?.data || [], this.ingredientSkip)
      },
      certificatesList() {
        return take(this.page.qualityCertificates?.data || [], this.certificatesSkip)
      },
      patentsList() {
        return take(this.page.patents?.data || [], this.patentsSkip)
      },
    },
    watch: {
      'newsPaginator.page'() {
        this.fetchNewsForPage()
      },
      $route() {
        this.fetchContentForPage()
        this.fetchContent()
      }
    },
    mixins: [dynamicsHead],
    async created() {
      await this.fetchContentForPage()
      await this.fetchContent()
      this.setPageMetaInfo(this.page)
    },
    methods: {
      ...mapActions({
        fetchPage: 'pages/GET_PAGE',
        fetchNewsPage: 'pages/GET_NEWS_PAGE',
        fetchTerm: 'pages/GET_ONE_TERM',

        fetchNews: 'pages/GET_NEWS',
        fetchCooperationTerms: 'pages/COOPERATION_TERMS',
        fetchCourseThemes: 'pages/WEBINAR_COURSE_THEMES',
      }),
      ...mapMutations({
        changeApplicationFormPopup: 'popups/CHANGE_APPLICATION_FORM_POPUP',
      }),
      copyLink() {
        navigator.clipboard.writeText(window.location.href);
        this.$toasted.success(this.$t('linkCopied'));
      },
      shareInstagram() {
        const url = window.location.href;
        window.open(`instagram://sharesheet?text=${url}`, "_blank");
      },
      shareTelegram() {
        const url = window.location.href;
        window.open(`https://t.me/share/url?url=${url}`, "_blank");
      },
      shareFacebook() {
        const url = window.location.href;
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, "_blank");
      },
      shareViber() {
        const url = window.location.href;
        window.open(`viber://forward?text=${url}`, "_blank");
      },
      shareMail() {
        const url = window.location.href;
        window.open(`mailto:?subject=SkinOn&amp;body=${url}`, "_blank");
      },
      handleVideoPlay(metodistBlock) {
        if (this.currentlyPlaying && this.currentlyPlaying !== metodistBlock) {
          this.currentlyPlaying.$refs.videoRef.pause()
          this.currentlyPlaying.playVideo = false
        }

        this.currentlyPlaying = metodistBlock
      },
      async fetchContentForPage() {
        if (!this.$route.query.type) {
          await this.fetchPage(this.$route.params.slug)
        } else if ('terms' === this.$route.query.type) {
          await this.fetchTerm(this.$route.params.slug)
        } else if ('new' === this.$route.query.type) {
          await this.fetchNewsPage(this.$route.params.slug)
        }
      },
      async fetchContent() {
        if ('scientific-news' === this.page.configType) {
          this.newsList = []
          await this.fetchNewsForPage()
        } else if ('terms-of-cooperation' === this.page.configType) {
          this.cooperationTerms = await this.fetchCooperationTerms()
        } else if ('online-education' === this.page.configType) {
          this.webinarCourseThemes = await this.fetchCourseThemes()
        }
      },
      async fetchNewsForPage() {
        this.loadingMoreContent = true

        const newsData = await this.fetchNews({
          page: this.newsPaginator.page,
          perPage: this.newsPaginator.perPage,
        })

        this.newsList.push(...newsData.data)

        this.newsPaginator.hasNextPage = !!newsData.links.next

        this.loadingMoreContent = false
      },
      isBigSecondTitle() {
        const pageConfigTypesForTitle = [
          'catalog-and-protocols',
          'application-for-presentation',
          'before-after',
          'terms-of-cooperation',
          'scientific-news',
          'patents',
          'innovative-ingredients',
          'partners',
        ]

        return this.$route.query.smallTitle || pageConfigTypesForTitle.includes(this.page.configType)
      },
      showPageTitle() {
        return !this.isBigSecondTitle()
      },
      loadMoreIngredients(skip) {
        this.ingredientSkip += skip
      },
      loadMoreCertificates(skip) {
        this.certificatesSkip += skip
      },
      loadMorePatents(skip) {
        this.patentsSkip += skip
      },
      loadMoreNews() {
        this.newsPaginator.page += 1
      },
    },
  }
</script>

<style scoped lang="scss">
.share-block {
  margin-top: 38px;
  padding-top: 32px;
  border-top: 1px solid #F1F1F1;
  display: flex;
  align-items: center;

  span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #000000;
  }

  a, button {
    text-decoration: none;
    margin-left: 7px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:first-child {
      margin-left: 30px;
    }

    svg {
      transition: color .3s ease-in-out;
      color: #4F4F4F;
    }

    &:hover svg {
      color: #000000;
    }
  }
}

  .page {
    .education {
      .withImage {
        width: calc(100% - 470px);
      }

      &-wrap {
        margin: 40px 0 50px;
        padding-bottom: 10px;
      }

      &-sub_title {
        margin-bottom: 10px;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #000000;
      }

      &__head {
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
        color: #828282;
        list-style: none;

        &-img {
          max-width: 450px;
          width: 100%;
          height: 700px;
          position: absolute;
          right: 15px;
          top: -77px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        li + li {
          margin-top: 20px;
        }

        li {
          a {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            text-decoration: none;

            .education__head-icon {
              width: 100px;
              height: 100px;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;

              svg,
              img {
                transition: ease-in-out 0.3s;
                width: 80%;
              }
            }

            .education__head-desc {
              width: calc(100% - 130px);

              h2,
              p {
                margin: 0;
              }

              h2 {
                display: inline-block;
                font-weight: 500;
                font-size: 20px;
                color: #000000;
                margin-bottom: 5px;
                border-bottom: 1px solid transparent;
                transition: ease-in-out 0.3s;
                text-transform: uppercase;
              }

              p {
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: #000000;
              }
            }

            &:hover {
              .platform__head-icon {
                img,
                svg {
                  transform: scale(1.05);
                  transition: ease-in-out 0.3s;
                }
              }

              .platform__head-desc {
                h2 {
                  border-color: black;
                  transition: ease-in-out 0.3s;
                }
              }
            }
          }
        }
      }

      &__patent {
        &-wrap {
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        &-img {
          width: 50%;
          height: 630px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        &-text {
          margin-left: -50px;
          width: 55%;
          background: #f2f2f2;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 30px 50px;

          .main-button {
            text-decoration: none;
          }

          &__button {
            max-width: 250px;
            margin: auto;
            margin-top: 20px;
          }

          &__title {
            font-weight: normal;
            font-size: 40px;
            line-height: 49px;
            text-transform: uppercase;
            color: #000000;
          }

          &__description {
            margin-top: 20px;
            font-weight: normal;
            font-size: 18px;
            line-height: 24px;
            color: #4f4f4f;

            ul {
              list-style: disc !important;
            }

            ol {
              list-style: decimal;
            }
          }
        }
      }
    }

    .our-metodist {
      &--wrap {
        margin-top: 40px;
        display: grid;
        gap: 32px;
        grid-template-columns: 1fr 1fr 1fr;
      }
    }

    .column_block-wrapper {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    ul {
      padding: 20px 0 20px 20px;
    }

    ol {
      padding: 20px 0 20px 20px;
    }

    .presentations {
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;
      align-items: center;

      iframe {
        width: 60%;
        height: 450px;
      }

      &__content {
        width: 43%;
        background: #f2f2f2;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 30px 50px;
        height: fit-content;

        h2 {
          font-size: 24px;
          line-height: 32px;
          text-transform: uppercase;
          color: #000000;
          margin-bottom: 0;
        }

        &_description {
          margin-top: 20px;
          font-weight: normal;
          font-size: 18px;
          line-height: 24px;
          color: #4f4f4f;
        }
      }
    }

    .certificate-list {
      display: flex;
      flex-wrap: wrap;
      margin-left: -60px;
      margin-right: -60px;
      //margin-top: -10px;
    }

    &-title {
      font-weight: normal;
      font-size: 40px;
      line-height: 49px;
      text-transform: uppercase;
      color: #000000;
      margin-top: 25px;

      &__second {
        font-weight: normal;
        font-size: 40px;
        line-height: 40px;
        color: #000000;
        margin-bottom: 10px;

        &.new {
          // max-width: 830px;
          margin: 0 auto;
          margin-bottom: 44px;
          font-weight: 500;
        }

        &.big {
          font-weight: normal;
          font-size: 40px;
          line-height: 49px;
          text-transform: uppercase;
          color: #000000;
        }
      }
    }

    .certificate,
    .patent,
    .news {
      &-load {
        display: flex;
        justify-content: center;
        margin-top: 55px;

        button {
          width: 200px;
          height: 50px;
        }
      }
    }

    &-certificate {
      width: calc(50% - 120px);
      margin: 0px 60px;
    }

    &-patent {
      margin-bottom: 55px;
    }

    .innovatives {
      width: 100%;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 10px;
      grid-auto-rows: 100px;
      grid-auto-flow: dense;

      &-load {
        display: flex;
        justify-content: center;
        margin-top: 55px;

        button {
          width: 200px;
          height: 50px;

          .loader {
            min-height: unset;
          }
        }
      }
    }

    &-new {
      margin-bottom: 55px;
    }

    &-innovative {
      background-color: grey;
      grid-row: span 2;
      cursor: pointer;

      &:nth-child(5n - 4) {
        grid-row: span 4;
      }

      &:nth-child(5n - 3) {
        grid-row: span 3;
      }

      &:nth-child(5n - 2) {
        grid-row: span 3;
      }

      &:nth-child(5n - 1) {
        grid-row: span 4;
      }

      &:nth-child(5n) {
        grid-row: span 3;
      }
    }

    &-before__after {
      margin-bottom: 100px;
    }

    &-button {
      display: flex;
      justify-content: center;
      height: 43px;
      margin: auto;

      button {
        max-width: 250px;
      }

      max-width: 1050px;
      width: 100%;
    }

    &-term {
      margin-bottom: 55px;
    }

    .protocols {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      margin-left: -40px;
      margin-right: -40px;
      justify-content: flex-start;

      &-placeholder {
        margin: 0 auto;

        h3 {
          text-align: center;
          font-size: 18px;
          font-weight: 500;
          color: #828282;
        }
      }
    }

    &-protocol {
      margin: 45px;
      margin-top: 0;
      width: calc(25% - 90px);
    }
  }

  @media screen and (max-width: 1280px) {
    //.page .container {
    //  max-width: 1050px;
    //  width: 100%;
    //}
    .static-content {
      .our-metodist--wrap {
        grid-template-columns: 1fr 1fr;
      }
    }
    .page-protocol {
      width: calc(30% - 45px);
      margin: 39px;
      margin-top: 0;
    }
  }

  @media screen and (max-width: 1140px) {
    .page-protocol {
      margin-top: 0;
      width: calc(45% - 45px);
      margin: 40px;
    }
    .page-certificate {
      width: 100%;
    }
    .page-title,
    .page-title__second.big {
      font-size: 32px;
    }
    .page-title__second {
      font-size: 22px;
      margin-top: 15px;
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: 980px) {
    .page .education .withImage {
      width: 100%;
    }
    .page .education__head-img {
      display: none;
    }
    .presentations {
      flex-direction: column;
    }
    .page .presentations iframe {
      width: 100%;
      height: 500px;
      margin-bottom: 30px;
    }
    .page .presentations__content {
      width: 100%;
      margin-left: 0;
    }
  }

  @media screen and (max-width: 850px) {
    .static-content {
      .our-metodist--wrap {
        margin-top: 0px;
        grid-template-columns: 1fr;
      }
    }
    .page .education__patent-text__title {
      font-size: 30px;
      line-height: 39px;
    }
    .page .education__patent-text__description {
      font-size: 16px;
      line-height: 20px;
    }
  }

  @media screen and (max-width: 750px) {
    //.page .education__patent-img img {
    //  height: 400px;
    //}
    .patent-text {
      padding: 30px;
      height: 350px;
    }
    .page .education__patent-text__title {
      font-size: 24px;
      line-height: 26px;
    }
    .page .education__patent-text__description {
      font-size: 16px;
      line-height: 18px;
      margin-top: 10px;
    }
  }

  @media screen and (max-width: 650px) {
    .page .education__patent-img {
      width: 100%;
      height: 400px;
    }
    .page .education__patent-wrap {
      flex-direction: column;
    }
    .page .education__patent-text {
      margin-left: 0;
      width: 100%;
      height: auto;
      padding: 30px;
    }
    .page .education__patent-img img {
      width: 100%;
    }
    .page .education__head-img {
      max-width: 100%;
      height: 550px;
      margin-bottom: 50px;
    }
  }

  @media screen and (max-width: 400px) {
    .patent-text {
      //height: 400px;
      margin-left: 0;
      padding: 15px;
    }
  }

  @media screen and (max-width: 900px) {
    .page-protocol {
      width: calc(100% - 45px);
      margin: 40px;
    }
    .page .presentations iframe {
      height: 400px;
    }
  }

  @media screen and (max-width: 720px) {
    .page .presentations iframe {
      height: 350px;
    }

    .page-certificate {
      margin: 0;
    }

    .certificate-list {
      margin-left: 0 !important;
      margin-right: 0 !important;

      .certificate-image,
      .certificate-wrap {
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 660px) {
    .page .education__patent-text__title[data-v-5c12baef] {
      font-size: 30px;
    }
    .page .presentations__content {
      padding: 24px 25px;
    }
    .page .presentations__content h2 {
      font-size: 24px;
      line-height: 26px;
    }
    .presentations__content_description {
      font-size: 16px;
      line-height: 18px;
      margin-top: 10px;
    }
    .page .presentations iframe {
      height: 250px;
    }
    .protocol-download {
      bottom: 20%;
      right: -40px;
    }
    .page-protocol {
      width: 100%;
      //margin: 0;
      margin-bottom: 40px;
    }
    .page .protocols {
      margin-left: 0;
      margin-right: 0;
    }
    .page-title {
      font-size: 24px;
    }
    .page-innovative {
      height: 250px;
    }
    .page .innovatives {
      display: flex;
      flex-direction: column;
    }
    .page .certificate-list {
      margin-top: -40px;
    }
  }
</style>
